export default {
  namespaced: true,
  state: {
    selected_menu: 0,
    list: [
      { title: "Proveedores", icon: require('../../assets/img/users.png'), link: "/admin/providers" }
    ]
  },
  mutations: {
    set_selected_menu(state, selected) {
      state.selected_menu = selected;
    }
  },
  actions: {
    selected_menu({ commit }, selected) {
      commit("set_selected_menu", selected);
    }
  },
  getters: {},
  setters: {},
  modules: {}
};
